module.exports = __webpack_public_path__ + "5ade89f42f5b5d53bf61aa02843c8815.woff2";